import React from "react";
import SymbolSearchBar from "../../../commonComponents/symbolSearchBar/symbol-search-bar";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectAccessToken } from "../../authentication/authentication-slice";
import { fetchAllSeries, selectStatus, selectSymbol, setPeriod, setSymbol } from "./stock-data-slice";
import MarketDataCategoryFilter from "./stock-data-category-filter";
import MarketDataSelection from "./stock-data-selection";
import StockDataChart from "./stock-data-chart";

const StockSummary: React.FC = () => {

  // Redux
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector(selectAccessToken);
  const status = useAppSelector(selectStatus);
  const symbol = useAppSelector(selectSymbol);


  // When searchbar symbol changes, fetch necessary market data
  function onSymbolChange(symbol: string): void {
    dispatch(setPeriod("5A"));
    dispatch(setSymbol(symbol));
    if (accessToken) {
      dispatch(fetchAllSeries({ accessToken }));
    }
  }

  return (
    <div className="flex flex-col w-full h-full mx-7 lg:mx-20 items-center select-none">
      <div className="flex flex-col w-full h-full lg:mb-20 items-center text-neutral-300">
        {/** Symbol search bar */}
        <div className="flex flex-row mt-5 mx-3 lg:min-h-14 justify-center">
          <SymbolSearchBar onSymbolChange={onSymbolChange} />
        </div>

        <div className={`flex flex-col lg:flex-row-reverse w-full h-full mt-7 lg:my-10 items-center lg:items-start
          ${(!symbol ? "opacity-0" : "opacity-100")}`}>

          <div className="flex lg:basis-5/12 flex-col w-full lg:mt-0 lg:mb-0 lg:ml-10 items-center">

            {/** categories filter */}
            <div>
              <MarketDataCategoryFilter />
            </div>

            {/** Horizontal line */}
            <div className="w-full h-1 mx-3 mt-3 border-b-2 border-blue-300/40 [mask-image:linear-gradient(to_right,transparent_0,transparent_10%,black_30%,black_70%,transparent_90%,transparent_100%)]" />

            {/** Horizontal line */}
            <div className="w-full h-1 mx-3 my-1 border-b-2 border-blue-300/60 [mask-image:linear-gradient(to_right,transparent_0,black_15%,black_85%,transparent_100%)]" />

            {/** market data selection */}
            <div className="my-5">
              <MarketDataSelection />
            </div>

            {/** Horizontal line */}
            <div className="w-full h-1 mx-3 my-1 border-b-2 border-blue-300/60 [mask-image:linear-gradient(to_right,transparent_0,black_15%,black_85%,transparent_100%)]" />

            {/** Horizontal line */}
            <div className="w-full h-1 mx-3 mb-3 border-b-2 border-blue-300/40 [mask-image:linear-gradient(to_right,transparent_0,transparent_10%,black_30%,black_70%,transparent_90%,transparent_100%)]" />

          </div>

          {/** Line chart */}
          <div className="flex flex-col lg:flex-row lg:basis-7/12 w-full h-80 lg:h-full mt-7 justify-center">
            <StockDataChart />
          </div>

        </div>
      </div>
    </div>
  )
}

export default StockSummary;